import { render, staticRenderFns } from "./TourGroupDocuments.vue?vue&type=template&id=62dbb656"
import script from "./TourGroupDocuments.vue?vue&type=script&lang=js"
export * from "./TourGroupDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports